/* src/app/front-layout/free-resourse/free-resourse.component.css */
.offers-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 60px;
  background:
    linear-gradient(
      to bottom,
      #ffffff 0%,
      #f8f9fa 100%);
  min-height: 100vh;
}
.offers-hero-banner {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 80px 5%;
  background:
    linear-gradient(
      135deg,
      #0077b6 0%,
      #005a8d 100%);
  color: #fff;
  border-radius: 0 0 50px 50px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 119, 182, 0.2);
}
.offers-hero-banner::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -10%;
  width: 600px;
  height: 600px;
  background:
    radial-gradient(
      circle,
      rgba(245, 197, 66, 0.15) 0%,
      transparent 70%);
  border-radius: 50%;
}
.offers-hero-banner::after {
  content: "";
  position: absolute;
  bottom: -30%;
  left: -5%;
  width: 400px;
  height: 400px;
  background:
    radial-gradient(
      circle,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 70%);
  border-radius: 50%;
}
.hero-content {
  margin-top: 100px;
  max-width: 55%;
  position: relative;
  z-index: 2;
  animation: fadeInLeft 0.8s ease-out;
}
@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.hero-subtitle {
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #F5C542;
  font-weight: 600;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.hero-subtitle::before {
  content: "\1f393";
  font-size: 18px;
}
.hero-title {
  font-size: 52px;
  font-weight: 800;
  margin: 15px 0;
  line-height: 1.2;
  color: white;
}
.hero-title .highlight {
  color: #F5C542;
  position: relative;
  display: inline-block;
}
.hero-title .highlight::after {
  content: "";
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  height: 8px;
  background: rgba(245, 197, 66, 0.3);
  z-index: -1;
}
.hero-description {
  font-size: 18px;
  margin: 25px 0 35px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.95);
}
.hero-btn {
  background: #F5C542;
  color: #0077b6;
  border: none;
  padding: 16px 40px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  border-radius: 50px;
  transition: all 0.3s ease;
  box-shadow: 0 8px 20px rgba(245, 197, 66, 0.3);
  text-transform: uppercase;
  letter-spacing: 1px;
}
.hero-btn:hover {
  background: white;
  color: #0077b6;
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(245, 197, 66, 0.4);
}
.hero-image {
  position: relative;
  z-index: 2;
  animation: fadeInRight 0.8s ease-out;
}
.hero-image img {
  width: 450px;
  height: auto;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  transition: transform 0.5s ease;
}
.hero-image img:hover {
  transform: scale(1.05) rotate(2deg);
}
.offers-section {
  padding: 60px 5%;
}
.section-header {
  text-align: center;
  margin-bottom: 50px;
}
.section-header h2 {
  font-size: 48px;
  font-weight: 800;
  color: #0077b6;
  margin-bottom: 15px;
}
.section-header h2::after {
  content: "";
  display: block;
  width: 100px;
  height: 5px;
  background:
    linear-gradient(
      to right,
      #F5C542,
      #0077b6);
  margin: 20px auto 0;
  border-radius: 10px;
}
.category-filter {
  display: flex;
  gap: 15px;
  margin: 0 auto 50px;
  justify-content: center;
  padding: 20px 0;
  flex-wrap: wrap;
}
.cat-pill {
  background-color: white;
  border: 2px solid #e0e0e0;
  border-radius: 50px;
  padding: 12px 28px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #555;
  text-transform: capitalize;
  outline: none;
}
.cat-pill:hover {
  border-color: #F5C542;
  color: #0077b6;
  transform: translateY(-2px);
}
.cat-pill.active {
  background:
    linear-gradient(
      135deg,
      #0077b6 0%,
      #005a8d 100%);
  color: white;
  border-color: #0077b6;
  box-shadow: 0 8px 20px rgba(0, 119, 182, 0.3);
}
.offers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 40px;
}
.offer-card {
  position: relative;
  cursor: pointer;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: flex;
  flex-direction: column;
}
.offer-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 40px rgba(0, 119, 182, 0.15);
}
.offer-card img {
  width: 100%;
  height: 180px;
  object-fit: cover;
  transition: transform 0.5s ease;
}
.offer-card:hover img {
  transform: scale(1.05);
}
.offer-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  background:
    linear-gradient(
      135deg,
      #F5C542 0%,
      #f4a742 100%);
  color: #0077b6;
  padding: 6px 16px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(245, 197, 66, 0.4);
  z-index: 2;
}
.offer-overlay {
  padding: 20px;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.offer-title {
  color: #0077b6;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
}
.offer-description {
  color: #666;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
}
.claim-offer-btn {
  background: #F5C542;
  color: #0077b6;
  border: none;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  border-radius: 50px;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: auto;
  align-self: flex-start;
}
.claim-offer-btn:hover {
  background: #0077b6;
  color: white;
  transform: translateX(5px);
}
.fade-in {
  animation: fadeIn 0.6s ease-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.no-data {
  text-align: center;
  font-size: 18px;
  color: #888;
  padding: 60px 20px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
  margin-top: 40px;
}
.loading-spinner {
  text-align: center;
  padding: 60px;
  font-size: 20px;
  color: #0077b6;
}
.error-message {
  text-align: center;
  padding: 40px;
  background: #fff3cd;
  border: 2px solid #F5C542;
  border-radius: 15px;
  color: #856404;
  font-size: 16px;
  margin-top: 40px;
}
@media (max-width: 1200px) {
  .offers-grid {
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
    gap: 35px;
  }
}
@media (max-width: 1024px) {
  .hero-content {
    max-width: 55%;
  }
  .hero-image img {
    width: 350px;
  }
  .hero-title {
    font-size: 42px;
  }
}
@media (max-width: 768px) {
  .offers-hero-banner {
    flex-direction: column;
    text-align: center;
    gap: 40px;
    padding: 60px 5%;
    border-radius: 0 0 30px 30px;
  }
  .hero-content,
  .hero-image {
    max-width: 100%;
  }
  .hero-image img {
    width: 100%;
    max-width: 400px;
  }
  .hero-title {
    font-size: 36px;
  }
  .hero-subtitle::before {
    margin: 0 auto;
  }
  .section-header h2 {
    font-size: 36px;
  }
  .offers-grid {
    grid-template-columns: 1fr;
    gap: 25px;
  }
  .category-filter {
    gap: 10px;
  }
  .cat-pill {
    padding: 10px 20px;
    font-size: 14px;
  }
}
@media (max-width: 480px) {
  .offers-hero-banner {
    padding: 40px 5%;
  }
  .hero-title {
    font-size: 28px;
  }
  .hero-description {
    font-size: 16px;
  }
  .hero-btn {
    padding: 14px 32px;
    font-size: 14px;
  }
  .section-header h2 {
    font-size: 28px;
  }
  .offer-card img {
    height: 180px;
  }
  .offer-title {
    font-size: 16px;
  }
}
/*# sourceMappingURL=free-resourse.component.css.map */
